import React from "react";
import PageLayout from "../components/layout/PageLayout";
import { Helmet } from "react-helmet-async";

const secciones = [
  {
    titulo: "1. Introducción",
    texto:
      "Bienvenido a nuestra página web. Al acceder y utilizar este sitio, aceptas las siguientes condiciones de uso. Si no estás de acuerdo con ellas, te pedimos que no utilices el sitio.",
  },
  {
    titulo: "2. Uso del Sitio",
    texto:
      "Está prohibido usar esta página web para actividades ilícitas, fraudulentas o que atenten contra los derechos de terceros. Nos reservamos el derecho de suspender o cancelar cuentas que infrinjan estas condiciones.",
  },
  {
    titulo: "3. Propiedad Intelectual",
    texto:
      "Todo el contenido de esta página, incluyendo textos, imágenes y diseño, está protegido por derechos de autor y no puede ser reproducido sin autorización previa.",
  },
  {
    titulo: "4. Modificaciones",
    texto:
      "Nos reservamos el derecho de actualizar estas condiciones en cualquier momento. Te recomendamos revisarlas periódicamente para estar al tanto de los cambios.",
  },
];

const CondicionesUso = () => {
  return (
    <PageLayout>
      <Helmet>
        <title>Condiciones de Uso - Procu</title>
        <meta
          name="description"
          content="Consulta las condiciones de uso de Procu. Conoce las normas y términos para utilizar nuestra plataforma de proveedores y licitaciones."
        />
        <meta name="keywords" content="condiciones de uso, términos y condiciones, Procu, proveedores, licitaciones, B2B" />
      </Helmet>

      <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6">
        <h1 className="text-3xl font-bold">Condiciones de Uso</h1>
        <div className="mt-6 flex flex-col gap-6">
          {secciones.map((seccion) => (
            <section key={seccion.titulo}>
              <h2 className="text-lg font-semibold">{seccion.titulo}</h2>
              <p className="mt-2 text-muted-foreground">{seccion.texto}</p>
            </section>
          ))}
        </div>
      </div>
    </PageLayout>
  );
};

export default CondicionesUso;
